import React, { useEffect, useRef, useState } from "react";
import "./Stats.css";

const statsData = [
  { number: 15, suffix: "+", label: "Warehouse in Karnataka and Goa" },
  { number: 2.5, suffix: "L+", label: "Pickups & Deliveries" },
  { number: 200, suffix: "+", label: "Skilled Staff" },
  { number: 300, suffix: "+", label: "Commercial Vehicles" },
];

const StatsSection = () => {
  const sectionRef = useRef();
  const [hasAnimated, setHasAnimated] = useState(false);
  const [counts, setCounts] = useState(statsData.map(() => 0));

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          statsData.forEach((stat, index) => {
            let start = 0;
            const end = stat.number;
            const duration = 2000;
            const step = Math.ceil(end / (duration / 16));

            const interval = setInterval(() => {
              start += step;
              if (start >= end) {
                start = end;
                clearInterval(interval);
              }
              setCounts((prev) => {
                const updated = [...prev];
                updated[index] = start;
                return updated;
              });
            }, 16);
          });
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, [hasAnimated]);

  return (
    <div className="stats-section" ref={sectionRef}>
      {statsData.map((stat, index) => (
        <div className="stat-item" key={index}>
          <h2>
            {counts[index]}
            {stat.suffix}
          </h2>
          <p>{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;
